const calltoaction = {
  touch1: '،للولوج',
  touch2: 'المسوا الشاشة',
  headerTitle2: 'مرحبا بكم في',
  headerTitle1: 'فضاء المقاول الشعبي',
};

export default calltoaction;
